"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partitionArray = void 0;
/**
 * Returns consecutive subarrays of an array, each of the same size (the final array may be smaller).
 */
function partitionArray(array, size) {
    if (size < 1) {
        throw new Error("'size' must be greater than zero");
    }
    if (!Array.isArray(array)) {
        throw new Error("'array' must be a valid array");
    }
    var slices = [];
    var i, j;
    for (i = 0, j = array.length; i < j; i += size) {
        slices.push(array.slice(i, i + size));
    }
    return slices;
}
exports.partitionArray = partitionArray;
